module.exports = __webpack_public_path__ + "img/25.b3bdacc8.jpg";